/**
 * Copy - Centered, Large module
 *
 * Simple copy module, with centered text.
 */

// Deps
import { createComponent, FelaComponent } from "react-fela";
import { combineRules } from "fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles } from "~/styleguide/typography";

export default function CopyTwoColumns({ block }) {
    const { heading, content, anchor_id } = block;

    if (!heading && !content && !content.length) return null;

    return (
        <Container id={anchor_id} className="module-copy-two-columns">
            {heading && (
                <FelaComponent
                    style={combineRules(headingStyle, textStyles.heading1)}
                    as="h3"
                >
                    <span dangerouslySetInnerHTML={{ __html: heading }} />
                </FelaComponent>
            )}

            <Columns>
                {content.map((entry, index) => {
                    return (
                        <Content key={index} count={content.length}>
                            {/* Bolded title */}
                            {entry.title && (
                                <FelaComponent
                                    style={combineRules(
                                        textStyles.paragraphLarge,
                                        subheadingStyle
                                    )}
                                    as="p"
                                >
                                    <strong dangerouslySetInnerHTML={{ __html: entry.title }} />
                                </FelaComponent>
                            )}

                            {/* Paragraph description */}
                            {entry.description && (
                                <Copy
                                    dangerouslySetInnerHTML={{
                                        __html: entry.description
                                    }}
                                />
                            )}
                        </Content>
                    );
                })}
            </Columns>
        </Container>
    );
}

const Container = createComponent(
    () => ({
        textAlign: "center",
        extend: [
            fluid("paddingH", gutters.default),
            fluid("paddingV", gutters.vertical)
        ]
    }),
    "div",
    ["id"]
);

const Columns = createComponent(() => ({
    display: "flex",
    flexWrap: "wrap",
    marginH: "auto",
    maxWidth: 1300
}));

const Content = createComponent(({ count }) => ({
    width: "33.333%",
    textAlign: "left",

    minWidthMobileLandscape: {
        grid: {
            cols: "2",
            margins: "100",
            length: count,
            bottomMargin: 30
        }
    },

    maxWidthMobileLandscape: {
        width: "100%",
        marginBottom: 40,
        ":last-child": {
            marginBottom: 0
        }
    }
}));

const Copy = createComponent(() => textStyles.paragraphLarge, "div", [
    "dangerouslySetInnerHTML"
]);

const headingStyle = {
    extend: [fluid("marginBottom", { min: 40, max: 80 })]
};

const subheadingStyle = {
    display: "block",
    marginBottom: 20
};
